var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
var APP_SESSION_STATE = 'DESIRA_SESSION_STATE';
var defaultState = {
    isAuthenticated: false
};
var SessionService = /** @class */ (function () {
    function SessionService(router, http) {
        this.router = router;
        this.http = http;
    }
    Object.defineProperty(SessionService.prototype, "session", {
        get: function () {
            try {
                var state = JSON.parse(localStorage.getItem(APP_SESSION_STATE));
                return state === null ? defaultState : state;
            }
            catch (err) {
                return defaultState;
            }
        },
        set: function (state) {
            localStorage.setItem(APP_SESSION_STATE, JSON.stringify(state));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SessionService.prototype, "isAuthenticated", {
        get: function () {
            return this.session.isAuthenticated;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SessionService.prototype, "isAdmin", {
        get: function () {
            return this.isAuthenticated && this.profile.software_role === 'ADMIN';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SessionService.prototype, "profile", {
        get: function () {
            return this.session.profile;
        },
        enumerable: true,
        configurable: true
    });
    SessionService.prototype.login = function (credentials) {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.http.post(environment.apiRoot + '/login', credentials, {
                                observe: 'response',
                                withCredentials: true
                            }).toPromise()];
                    case 1:
                        response = _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        console.error('Failed to login', response);
                        return [2 /*return*/, {
                                succeeded: false
                            }];
                    case 3:
                        if (response.status !== 200) {
                            console.error('Failed to login', response);
                            return [2 /*return*/, {
                                    succeeded: false
                                }];
                        }
                        this.session = {
                            isAuthenticated: true,
                            profile: response.body
                        };
                        console.log(this.session);
                        return [2 /*return*/, {
                                succeeded: true
                            }];
                }
            });
        });
    };
    SessionService.prototype.resetSession = function () {
        this.session = defaultState;
    };
    SessionService.prototype.logout = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.resetSession();
                // TODO: Logout via backend
                // Clear cache & JS environment
                window.location.assign('/login');
                return [2 /*return*/];
            });
        });
    };
    return SessionService;
}());
export { SessionService };
